import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=765e6c36&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=765e6c36&prod&lang=scss&scoped=true"
import style1 from "./goods.vue?vue&type=style&index=1&id=765e6c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e6c36",
  null
  
)

export default component.exports